(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["rc-coupon-box"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('rc-coupon-box')) return;

    // Production's key, so the placebo "applied" state is shared with the legacy product pages.
    const STORAGE_KEY = 'rcCouponApplied';

    /** @param {Element} box */
    const markApplied = (box) => {
      box.classList.add('is-applied');
      box.querySelector('[data-coupon-apply]')?.setAttribute('disabled', 'disabled');
    };

    class RcCouponBox extends HTMLElement {
      // A field, not a data attribute: Horizon's morph keeps this element (so connectedCallback does
      // not run again) but strips attributes the server HTML lacks.
      #bound = false;

      connectedCallback() {
        this.syncAppliedState();
        if (this.#bound) return;
        this.#bound = true;

        // Find the box at click time: a morph can add or replace it after connection.
        this.addEventListener('click', (event) => {
          const button = event.target instanceof Element ? event.target.closest('[data-coupon-apply]') : null;
          const box = button?.closest('[data-promo-coupon-box]');
          if (!box || box.classList.contains('is-applied')) return;

          markApplied(box);
          try {
            sessionStorage.setItem(STORAGE_KEY, box.getAttribute('data-coupon-code') || '');
          } catch (error) {
            // Storage unavailable: the applied state lasts for this page view only.
          }
          console.log('[rc-coupon-box] placebo apply:', box.getAttribute('data-coupon-code'));
        });
      }

      /** Re-applies the stored placebo state; a morph resets it. */
      syncAppliedState() {
        const box = this.querySelector('[data-promo-coupon-box]');
        if (!box) return;

        try {
          if (sessionStorage.getItem(STORAGE_KEY) === box.getAttribute('data-coupon-code')) markApplied(box);
        } catch (error) {
          // Storage unavailable (private mode): the box simply starts in its apply state.
        }
      }

      /** @param {string} variantId */
      showSavingsFor(variantId) {
        const map = this.querySelector('script[data-coupon-savings-map]');
        if (!map) return;

        let savings = {};
        try {
          savings = JSON.parse(map.textContent || '{}');
        } catch (error) {
          return;
        }

        const text = savings[variantId];
        if (!text) return; // not one of this product's variants
        this.querySelectorAll('[data-coupon-savings]').forEach((element) => {
          element.textContent = text;
        });
      }
    }

    customElements.define('rc-coupon-box', RcCouponBox);

    // Horizon announces the resolved variant after a variant change, after any morph of the section:
    // restore the placebo state, then show that variant's savings, in the boxes of that scope.
    document.addEventListener('variant:update', (event) => {
      const variantId = event.detail?.resource?.id;
      const origin = event.target instanceof Element ? event.target : null;
      const scope = origin?.closest('.shopify-section, dialog') || document;
      scope.querySelectorAll('rc-coupon-box').forEach((element) => {
        if (!(element instanceof RcCouponBox)) return;
        element.syncAppliedState();
        if (variantId) element.showSavingsFor(String(variantId));
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
